import AccordionItem from "./AccordionItem";
import { useState, useEffect } from "react";

const Accordion = ({
  servicesGroup,
  selectedServices,
  onSelectService,
  handleQuantityChange,
}) => {
  const [openIndices, setOpenIndices] = useState([]); // now it's an array

  const handleToggle = (index) => {
    setOpenIndices((prev) => {
      if (prev.includes(index)) {
        // close if already open
        return prev.filter((i) => i !== index);
      } else {
        // open new group
        return [...prev, index];
      }
    });
  };

  return (
    <div className="accordion" id="accordionExample">
      {servicesGroup.map((group, index) => (
        <AccordionItem
          key={group.id}
          group={group}
          isOpen={openIndices.includes(index)}
          onToggle={() => handleToggle(index)}
          selectedServices={selectedServices}
          onSelectService={onSelectService}
          handleQuantityChange={handleQuantityChange}
        />
      ))}
    </div>
  );
};
export default Accordion;
